import Vue from 'vue'

import App from './App.vue'

import './registerServiceWorker'
// VueRouter
import router from './router'
// Vuex: Global Store
import store from './store/index'
// Boostrap Vue
import { BootstrapVue } from 'bootstrap-vue'
// Global Components
import Icon from './components/Icon'
// Icons SVG
import $icons from './icons'
// Aws
import Amplify from 'aws-amplify'
// Maps
import * as VueGoogleMaps from 'vue2-google-maps'
// Vue Analytics
import VueAnalytics from 'vue-analytics'
// Enviroments
import configPlugin, { config } from '@/config'
// Vue Apollo
import apolloProvider from './vue-apollo'
// Auth
import AuthService from './services/auth'

const auth = new AuthService()

Vue.config.productionTip = false

Vue.component('Icon', Icon)
Vue.use(configPlugin)
Vue.use(BootstrapVue)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDUDvqujb60l9FZxKnQaTwS5OoRIFp3xbk',
    libraries: 'places'
  }
})

Vue.use(VueAnalytics, {
  id: 'UA-146676380-1',
  router,
  autoTracking: {
    exception: true
  }
})

Amplify.configure({
  Auth: {
    region: config.region,
    userPoolId: config.userPoolId,
    userPoolWebClientId: config.userPoolWebClientId
  }
})

Vue.prototype.$bus = new Vue()

new Vue({
  router,
  store,
  $icons,
  apolloProvider,
  async beforeCreate () {
    if (await auth.isAuthenticated()) store.dispatch('getUser')
  },
  render: h => h(App)
}).$mount('#app')
